import { CommonModule } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CallDeviceControllerComponent } from 'src/app/shared/components/call-device-controller/call-device-controller.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { ShareMenuComponent } from 'src/app/shared/services/share-menu/share-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContentModule } from '../content/content.module';
import { AppCalendarComponent } from './app-calendar/app-calendar.component';
import { AppCalendarService } from './app-calendar/app-calendar.service';
import { CalendarConfigComponent } from './app-calendar/calendar-config/calendar-config.component';
import { CalendarFormDialogComponent } from './app-calendar/calendar-form-dialog/calendar-form-dialog.component';
import { TodoTableComponent } from './todo-table/todo-table.component';
import { TodosConfigComponent } from './todos/todos-config/todos-config.component';
import { TodosComponent } from './todos/todos.component';
import { UserGroupListComponent } from './user-group-list/user-group-list.component';

const standalones = [ShareMenuComponent, CallDeviceControllerComponent];
const classesToInclude = [
  AppCalendarComponent,
  CalendarConfigComponent,
  CalendarFormDialogComponent,
  TodosComponent,
  TodosConfigComponent,
  TodoTableComponent,
  UserGroupListComponent,
];

@NgModule({
  declarations: classesToInclude,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule,
    ContentModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    TranslateModule,
    ...standalones,
  ],
  providers: [AppCalendarService, { provide: LOCALE_ID, useValue: 'fr-FR' }],
})
export class EventModule {}
